import { PcrStaffApplicationsStatistics } from '../../lib/types/models/pcr/pcr-statistics'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getPcrStaffApplicationsStatistics(pcrId: number) {
  return restApiClient
    .url(constructApiUrl(API.pcr.getStaffApplicationsStatistics.url, { id: pcrId }))
    .get<PcrStaffApplicationsStatistics>()
}
